// extracted by mini-css-extract-plugin
export var animate = "AnimationDetailsPanel-module--animate--9817e";
export var contextBlock = "AnimationDetailsPanel-module--contextBlock--300f3";
export var contextWrap = "AnimationDetailsPanel-module--contextWrap--8773a";
export var grey = "AnimationDetailsPanel-module--grey--8459a";
export var location = "AnimationDetailsPanel-module--location--42639";
export var metric = "AnimationDetailsPanel-module--metric--d2a64";
export var metricBlock = "AnimationDetailsPanel-module--metricBlock--88469";
export var metricContent = "AnimationDetailsPanel-module--metricContent--9bdf9";
export var slideout = "AnimationDetailsPanel-module--slideout--07cf5";